export default __webpack_public_path__ + "static/media/themis.25a8686d.jpeg";